import { queryKeys } from "../queryKeys";
import { getWatchlists, type Watchlist } from "../rest/account";
import useRequest, { type QueryOptions } from "./useRequest";

export const useGetWatchlists = ({
  accountID = "",
  options,
}: {
  accountID?: string;
  options?: QueryOptions<Watchlist[]>;
}) => {
  const {
    data: watchlists,
    refetch,
    isFetched,
  } = useRequest(
    queryKeys.watchlists.list(accountID || ""),
    () => getWatchlists({ accountID }),
    {
      ...options,
      refetchInterval: false,
    },
  );

  return { watchlists: watchlists ?? [], refetch, isFetched };
};

export default useGetWatchlists;
